export default "__VITE_ASSET__CRhzb7qE__"